<div class="groups-list">
  <div class="groups-sidebar">
    <button type="button" [disabled]="!isLicenseValid" (click)="onAddGroup()" pButton icon="fa fa-plus-square-o" label="New Device Group" class="add-button"></button>
    <p></p>
    @for (group of allGroups; track group) {
      <div class="row list-row">
        <div class="col-10">
          <span class="clickable-device-group-item" [class.active]="selectedDisplayGroup == group" (click)="onSelectGroup(group)">
            <i class="fa fa-arrow-right" style="margin-right: 5px;"></i>{{group.Name}}
          </span>
        </div>
        <div class="col-2">
          <button class="btn btn-danger" type="button" [disabled]="!isLicenseValid" (click)="onDeleteGroup(group)">
            <i class="pi pi-trash"></i>
          </button>
        </div>
      </div>
    }
  </div>

  @if (!!selectedGroup) {
    <div style="order: 2; flex-grow: 1; overflow-x:hidden">
      <device-group-editor [target]="selectedGroup" [network]="target" (onApply)="onAppliedChange()"></device-group-editor>
    </div>
  }

  @if (!selectedGroup) {
    <div
      class="no-group">
      <div>Select a device group to view/edit its details, or</div>
      <div>Click &quot;New Device Group&quot; to create a new device group</div>
    </div>
  }

  <p-dialog [(visible)]="showTempChangesDialog">
    <p-header>
      <span>Unapplied Changes</span>
    </p-header>
    <p>Your changes have not been applied, and will be lost if you continue.</p>
    @if (showTempChangesDialog && !applyTempChangesEnabled) {
      <p>
        Some of the changes are currently invalid and cannot be applied.
      </p>
    }
    <p>Select one of the options below.</p>
    <p-footer>
      @if (showTempChangesDialog && applyTempChangesEnabled) {
        <button type="button" pButton [disabled]="!isLicenseValid"
        (click)="onApplyTempChanges()" label="Apply Changes"></button>
      }
      <button type="button" pButton (click)="onDiscardTempChanges()" label="Discard Changes"></button>
      <button type="button" pButton (click)="onCancelNavigation()" label="Cancel"></button>
    </p-footer>
  </p-dialog>

</div>
